const registrantScanActions = {
    CHECK_IN: "IN",
    CHECK_OUT: "OUT",
    PRINT_BADGE: "PRINT_BADGE",
    VIEW_DETAILS: "VIEW_DETAILS",
}

export default registrantScanActions;
